import { render, staticRenderFns } from "./VPSRegistrationSuccessful.vue?vue&type=template&id=771e9ca8&scoped=true"
import script from "./VPSRegistrationSuccessful.vue?vue&type=script&lang=js"
export * from "./VPSRegistrationSuccessful.vue?vue&type=script&lang=js"
import style0 from "./VPSRegistrationSuccessful.vue?vue&type=style&index=0&id=771e9ca8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "771e9ca8",
  null
  
)

export default component.exports